import { intervalToDuration } from "date-fns";
import { ParentalConsent } from "@scrile/api-provider/dist/api/ParentalConsentProvider";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";

export const isUserUnderAge = (personalInfo: PersonalInformation | null) => {
  const dateOfBirth = personalInfo?.dateOfBirth;
  if (dateOfBirth) {
    const { years = 0 } = intervalToDuration({ start: new Date(dateOfBirth), end: new Date(Date.now()) });
    return years < 18;
  }
  return false;
};

export const allowParentalAccess = (consent: ParentalConsent | null) => !!consent;
